import { Loader } from "@mantine/core";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { features } from "shared/graphql/features";
import { permissionCheck, usePermissions } from "shared/stores/oidc";
import { logger } from "shared/utils/logger";
import { Permission } from "src/gql/graphql";
import { match } from "ts-pattern";

/** @public */
export const Route = createFileRoute("/_auth/organization/")({
    component: () => {
        const nav = useNavigate();
        const { permissions } = usePermissions();
        const hasTopics = features.enabled("HAS_TOPICS");

        useEffect(() => {
            match(permissions)
                .when(
                    (p) => permissionCheck(p, Permission.GroupSubgroupManage),
                    () => nav({ to: "/organization/groups" }),
                )
                .when(
                    (p) => hasTopics && permissionCheck(p, Permission.TopicCategoryManage),
                    () => nav({ to: "/organization/topics" }),
                )
                .when(
                    (p) => permissionCheck(p, Permission.CustomerShapeManage),
                    () => nav({ to: "/organization/geolocations" }),
                )
                .otherwise(() => nav({ to: "/organization/users" }))
                .catch(logger.error);
        }, []);

        return <Loader />;
    },
});
